import Delegate from "ftdomdelegate";
import { qs, remove, toggle, contains, listen } from "@fluorescent/dom";
import { emit } from "@/glow/events";
import AccountLogin from "@/lib/account/login";

const selectors = {
  accountLink: "[data-account-link]",
  accountLogin: "[data-account-login][data-scope='component']",
  accountOverview: ".account-overview",
};

const classes = {
  active: "active",
};

export default function (node) {
  if (!node) return;

  const linkWrapper = node.parentNode;
  const accountLink = qs(selectors.accountLink, linkWrapper);
  const isLoginForm = Boolean(qs(selectors.accountLogin, node));
  let accountLogin;

  if (isLoginForm) {
    accountLogin = AccountLogin(node);
  }

  const delegate = new Delegate(document.body);
  delegate.on("click", null, e => handleClick(e));

  const events = [
    listen(accountLink, "click", e => {
      e.preventDefault();
      e.stopPropagation();

      /*
        TODO: Explore using the associated settings to change the header account/cart links
        into buttons when 'enable_quick_sign_in' and 'enable_quick_cart' are enabled. This should negate
        the need for this hack of emitting an event to get around `e.stopPropagation()` preventing other
        popups from closing.
      */
      emit("header-account-link:clicked");
      toggleQuickView();
    }),
    listen(node, "keydown", ({ keyCode }) => {
      if (keyCode === 27) close();
    }),
  ];

  function toggleQuickView() {
    toggle(accountLink, classes.active, !contains(node, classes.active));
    toggle(node, classes.active, !contains(node, classes.active));
    node.setAttribute("aria-hidden", !contains(node, classes.active));
  }

  function handleClick(e) {
    if (
      !e.target.closest(selectors.accountLogin) &&
      !e.target.closest(selectors.accountOverview)
    ) {
      if (!contains(node, classes.active)) return;
      close();
    }
  }

  function close() {
    remove(accountLink, classes.active);
    remove(node, classes.active);
    node.setAttribute("aria-hidden", true);
  }

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
    accountLogin?.unload();
  };

  return { unload };
}
